module.exports = __webpack_public_path__ + "static/media/auth-back-arrow.a8137729.svg";